import { Component, inject, OnDestroy, signal } from '@angular/core';
import { LoginFacade } from '../../state/login.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
})
export class LoginDialogComponent implements OnDestroy {
  private readonly configService = inject(ConfigService);
  private readonly loginFacade = inject(LoginFacade);
  private readonly data = inject(MAT_LEGACY_DIALOG_DATA);
  private readonly dialogRef = inject(MatLegacyDialogRef<LoginDialogComponent>);

  readonly loginOpen = toSignal(this.loginFacade.open$);
  readonly loginScreen = toSignal(this.loginFacade.screen$);
  readonly helpUrl = signal<string>(this.configService.get().helpUrl);
  readonly disabledClose = signal<boolean>(this.dialogRef.disableClose);

  constructor() {
    this.loginFacade.changeScreen(this.data?.screen ?? 'login');
  }

  /**
   * Remove this code block when we use the openDialog action
   */
  ngOnDestroy(): void {
    this.loginFacade.changeLastScreen('');
  }

  openHelp() {
    window.open(this.helpUrl(), '_blank', 'noopener');
  }

  closeDialog() {
    this.dialogRef.close();
    this.loginFacade.closeDialog();
  }
}
